// extracted by mini-css-extract-plugin
export default {"content":"MI-z"};